/* eslint-disable */
import { noop, find } from 'lodash';
import { aapiBeacon } from '../../../../../javascript/services/analytics/aapi';

window.common_app.controller('LotCtrl', [
  '$scope',
  '$uibModal',
  'Customer',
  '$sessionStorage',
  '$http',
  '$exceptionHandler',
  '$anchorScroll',
  '$artpModalErrorHandler',
  'artpJson',
  '$artpHttpErrorHandler',
  'viewport',
  function ($scope, $uibModal, Customer, $sessionStorage, $http, $exceptionHandler, $anchorScroll, $artpModalErrorHandler, artpJson, $artpHttpErrorHandler, viewport) {
    $scope.order_by = 'artist';

    $scope.open_reproduction = function (idlot) {
      if (viewport.isMobile()) {
        return;
      }

      $scope.modal_reproduction = $uibModal.open({
        templateUrl: `/lots/reproduction/${idlot}?index=${$scope.currentImageIndex}`,
        size: 'lg',
        scope: $scope,
        controllerAs: 'reproductionVm',
        windowClass: 'lot-image-modal',
        controller: [
          function () {
            const vm = this;
            vm.urls = [];
            vm.geometries = [];
            vm.displayedGeometry = null;
            vm.currentIndex = 0;
            vm.contained = true;
            vm.init = function (urls, geometries, currentIndex) {
              aapiBeacon('lotimage', { idlot, index: currentIndex, op: 'zoom' });
              vm.currentIndex = currentIndex;
              vm.urls = urls;
              vm.geometries = geometries;
              const $el = $('#modal-image');
              return $el.on('load', () => (vm.displayedGeometry = [$el.width(), $el.height()]));
            };

            vm.nextUrl = () => {
              const newIndex = (vm.currentIndex + 1) % vm.urls.length;
              aapiBeacon('lotimage', { idlot, index: newIndex, op: 'zoom' });
              vm.currentIndex = newIndex;
            };

            vm.prevUrl = () => {
              const newIndex = (vm.currentIndex + vm.urls.length - 1) % vm.urls.length;
              aapiBeacon('lotimage', { idlot, index: newIndex, op: 'zoom' });
              vm.currentIndex = newIndex;
            };

            vm.toggleZoom = function ($event) {
              $event.stopPropagation();
              return (vm.contained = !vm.contained);
            };

            vm.isInContainMode = function () {
              if (!Array.isArray(vm.displayedGeometry)) {
                return true;
              }
              if (!Array.isArray(vm.geometries[vm.currentIndex])) {
                return true;
              }
              return vm.displayedGeometry[0] < vm.geometries[vm.currentIndex][0] || vm.displayedGeometry[1] < vm.geometries[vm.currentIndex][1];
            };

            return vm;
          },
        ],
      });
      return $scope.modal_reproduction.result.then(noop, $artpModalErrorHandler);
    };

    $scope.initImages = function (urls) {
      $scope.urls = urls;
      return ($scope.currentImageIndex = 0);
    };

    $scope.nextImg = function (idlot) {
      if ($scope.currentImageIndex + 1 === $scope.urls.length) {
        $scope.currentImageIndex = 0;
      } else {
        $scope.currentImageIndex += 1;
      }

      aapiBeacon('lotimage', { idlot, index: $scope.currentImageIndex, op: 'detail' });
    };

    return ($scope.previousImg = function (idlot) {
      if ($scope.currentImageIndex - 1 === -1) {
        $scope.currentImageIndex = $scope.urls.length - 1;
      } else {
        $scope.currentImageIndex -= 1;
      }

      aapiBeacon('lotimage', { idlot, index: $scope.currentImageIndex, op: 'detail' });
    });
  },
]);
